import firebase from "firebase/compat/app";
import "firebase/compat/database"
const firebaseConfig = {
  apiKey: "AIzaSyDnMF5xBz154rbzaLm9Kp3ExDLj5vii_ro",
  authDomain: "causalfunnel-21.firebaseapp.com",
  // databaseURL: "https://delete-104.firebaseio.com/",
  databaseURL: "https://causalfunnel-21-dailystats.firebaseio.com/",
  projectId: "causalfunnel-21",
  storageBucket: "causalfunnel-21.appspot.com",
  messagingSenderId: "210366452701",
  appId: "1:210366452701:web:6f3882a8808f97a0585c34",
  measurementId: "G-3STGPJXGSY"
};

const firebase_rootDB = firebase.initializeApp(firebaseConfig);
export default firebase_rootDB.database().ref('CF_Contact_Form_Data/graph-contact');

